import * as pdfjsLib from "pdfjs-dist/build/pdf";

// ✅ CRA-safe worker resolution (NO default import)
// pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
//     "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
//     import.meta.url
// ).toString();

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdfjs/pdf.worker.mjs";

export async function getPageCount(file) {
    if (!file) return 0;

    // Images = 1 page
    if (file.type !== "application/pdf") {
        return 1;
    }

    const buffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;

    return pdf.numPages;
}
